import * as _ from 'lodash';
import { Component, Injector } from '@angular/core';
import { FilterByComponent } from '../abstract-filter-by.component';

@Component({
    selector: 'filters-by-is-expert',
    templateUrl: './filters-by-is-expert.component.html',
    styleUrls: ['./filters-by-is-expert.component.scss']
})
export class FiltersByIsExpertComponent extends FilterByComponent {

    public isExpertEnabled: boolean = false;

    constructor(
        protected injector: Injector
    ) {
        super(injector);
        this.filterKey = 'is-expert';
    }

    initValue(listFilters: any) {
        if (this.filterKey in listFilters) {
            this.isExpertEnabled = listFilters[this.filterKey];
        }
    }

    onChange() {
        if (!this.isExpertEnabled) {
            const filters = this.serviceListings.filters;
            if (this.filterKey in filters) {
                delete filters['is-expert'];
                this.serviceListings.filters = filters;
            }
            this.isFiltersDirty.emit({ filterKey: this.filterKey, isDirty: false });
        } else {
            this.serviceListings.filters = _.extend(this.serviceListings.filters, {
                'is-expert': this.isExpertEnabled
            });
            this.checkIsDirty(this.isExpertEnabled, this.filterKey);
        }
        this.serviceListings.dataStoreChanged();
        this.saveFilter();
    }

    reset() {
        this.isExpertEnabled = false;
        const filters = this.serviceListings.filters;
        delete filters[this.filterKey];
        this.serviceListings.filters = filters;
        this.isFiltersDirty.emit({ filterKey: this.filterKey, isDirty: false });
    }
}
